/**
 * Blog Filter.
 */

export function blogFilterInit() {
	const select = document.getElementById( 'category-select' );
	const form   = document.getElementById( 'category-select__form' );
	if ( ! select || ! form ) {
		return;
	}

	select.addEventListener( 'change', function () {
		form.submit();
	} );
}
